/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetMenuOrdersResponseAllOf,
    GetMenuOrdersResponseAllOfFromJSON,
    GetMenuOrdersResponseAllOfFromJSONTyped,
    GetMenuOrdersResponseAllOfToJSON,
    MenuOrder,
    MenuOrderFromJSON,
    MenuOrderFromJSONTyped,
    MenuOrderToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetMenuOrdersResponse
 */
export interface GetMenuOrdersResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<MenuOrder>}
     * @memberof GetMenuOrdersResponse
     */
    menuOrders: Array<MenuOrder>;
}

export function GetMenuOrdersResponseFromJSON(json: any): GetMenuOrdersResponse {
    return GetMenuOrdersResponseFromJSONTyped(json, false);
}

export function GetMenuOrdersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrdersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'menuOrders': ((json['menuOrders'] as Array<any>).map(MenuOrderFromJSON)),
    };
}

export function GetMenuOrdersResponseToJSON(value?: GetMenuOrdersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'menuOrders': ((value.menuOrders as Array<any>).map(MenuOrderToJSON)),
    };
}


